import React from "react";
import PropTypes from "prop-types";
import { OutboundLink } from "gatsby-plugin-google-gtag";
import darkLogoWithText from "./yt_logo_mono_dark.png";
import lightLogoWithText from "./yt_logo_mono_light.png";

// To comply with YouTube Policy, the logo and text should come from Google only, no font awesome.
export const Youtube = ({ dark, children, ...others }) => (
  <OutboundLink
    {...others}
    href="https://www.youtube.com/channel/UCEwM5W3Ne0rZzLWix77kcqA/feed"
  >

    <span className="social-img">
      <img alt="Youtube Logo" src={dark? darkLogoWithText: lightLogoWithText} style={{lineHeight: "14px", height: "14px", paddingRight: "4px"}}/>
      {/* <i className="fab fa-youtube" />{" "} */}
    </span>
    {/* {children || "YouTube"} */}
  </OutboundLink>
);

Youtube.propTypes = {
  children: PropTypes.object,
};